import { Controller } from "@hotwired/stimulus"

// Native <dialog> mirroring its turbo-frame: open when the frame has content,
// close when it's empty. Handles frame loads, morphs, Escape, and backdrop
// clicks the same way — just keep the two in sync.
export default class extends Controller {
  connect() {
    this.frame = this.element.querySelector("turbo-frame")
    this.sync()
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.frame, { childList: true, subtree: true })
    this.element.addEventListener("close", this.clear)
  }

  disconnect() {
    this.observer.disconnect()
    this.element.removeEventListener("close", this.clear)
  }

  sync = () => {
    const filled = this.frame.innerHTML.trim().length > 0
    if (filled && !this.element.open) this.element.showModal()
    else if (!filled && this.element.open) this.element.close()
  }

  clear = () => {
    this.frame.innerHTML = ""
    this.frame.removeAttribute("src")
  }

  // Backdrop click (the dialog element itself, outside its content).
  backdrop(e) { if (e.target === this.element) this.element.close() }
}
